import { Component, effect, inject, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameService } from '../../../core/state/game.service';
import { IconComponent } from '../icon/icon.component';
import { ClubShieldComponent } from '../club-shield/club-shield.component';
import { Language } from '../../../core/i18n/translations';

@Component({
  selector: 'app-settings-modal',
  standalone: true,
  imports: [CommonModule, IconComponent, ClubShieldComponent],
  templateUrl: './settings-modal.component.html',
  host: {
    '(document:keydown.escape)': 'onEscape()'
  }
})
export class SettingsModalComponent {
  readonly game = inject(GameService);

  readonly isOpen = input<boolean>(false);
  readonly closed = output<void>();

  readonly activeTab = signal<'wallet' | 'preferences' | 'profile'>('preferences');

  constructor() {
    effect(() => {
      if (this.isOpen()) this.activeTab.set('preferences');
    });
  }

  close(): void {
    this.closed.emit();
  }

  async handleLogout(): Promise<void> {
    this.close();
    await this.game.logout();
  }

  setTab(tab: 'wallet' | 'preferences' | 'profile'): void {
    this.activeTab.set(tab);
  }

  topUpCredits(amount: number): void {
    this.game.topUpCredits(amount);
  }

  paySubscription(): void {
    this.game.payMonthlySubscription();
  }

  selectLanguage(lang: Language): void {
    this.game.i18n.setLanguage(lang);
  }

  onEscape(): void {
    if (this.isOpen()) {
      this.close();
    }
  }
}
